// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var AutocompleteVirtualized = require("../ui-utils/AutocompleteVirtualized.bs.js");
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var Delete = require("@mui/icons-material/Delete").default;
var Expln_React_TextFileReader = require("@expln/utils/src/main/react-components/Expln_React_TextFileReader.bs.js");

function MM_cmp_context_selector_single(Props) {
  var onFileChange = Props.onFileChange;
  var fileName = Props.fileName;
  var parseError = Props.parseError;
  var readInstr = Props.readInstr;
  var onReadInstrChange = Props.onReadInstrChange;
  var label = Props.label;
  var onLabelChange = Props.onLabelChange;
  var allLabels = Props.allLabels;
  var renderDeleteButton = Props.renderDeleteButton;
  var onDelete = Props.onDelete;
  var rndDeleteButton = function (param) {
    if (renderDeleteButton) {
      return React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onDelete, undefined);
                    }),
                  children: React.createElement(Delete, {})
                });
    } else {
      return null;
    }
  };
  var rndReadInstrTypeSelector = function (param) {
    return React.createElement(FormControl, {
                size: "small",
                children: null
              }, React.createElement(InputLabel, {
                    id: "scope-type-select-label",
                    children: "Scope"
                  }), React.createElement(Select, {
                    labelId: "scope-type-select-label",
                    label: "Scope",
                    value: readInstr,
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(onReadInstrChange, param);
                      }),
                    children: null
                  }, React.createElement(MenuItem, {
                        value: "all",
                        children: "Read all"
                      }), React.createElement(MenuItem, {
                        value: "stopBefore",
                        children: "Stop before"
                      }), React.createElement(MenuItem, {
                        value: "stopAfter",
                        children: "Stop after"
                      })));
  };
  var rndLabelSelector = function (param) {
    return React.createElement(AutocompleteVirtualized.make, {
                value: label,
                options: allLabels,
                onChange: onLabelChange,
                size: "small"
              });
  };
  var rndFileSelector = function (param) {
    if (Belt_Option.isNone(fileName) || Belt_Option.isNone(parseError)) {
      return React.createElement(Expln_React_TextFileReader.make, {
                  onChange: onFileChange
                });
    } else {
      return React.createElement("span", undefined, Belt_Option.getWithDefault(fileName, "<fileName>"));
    }
  };
  var rndReadInstr = function (param) {
    if (parseError !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, "Error: " + parseError);
    } else if (fileName !== undefined) {
      return React.createElement(Expln_React_Row.make, {
                  children: null
                }, rndReadInstrTypeSelector(undefined), readInstr === "stopAfter" || readInstr === "stopBefore" ? rndLabelSelector(undefined) : null);
    } else {
      return null;
    }
  };
  return React.createElement(Expln_React_Row.make, {
              alignItems: "center",
              spacing: 1,
              children: null
            }, rndDeleteButton(undefined), rndFileSelector(undefined), rndReadInstr(undefined));
}

var make = MM_cmp_context_selector_single;

exports.make = make;
/* react Not a pure module */
